// handle dark mode storage
window.anonymous = {
    on: false,
    init: function() {
        this.on = this.isOn();
        this.update();
        //ensure anonymous mode is off on all pages that aren't compare
        let url = location.pathname.replace('/', '');
        if(url != 'comparison') {
            this.set(false);
        }
    },
    set: function( active ) {
        localStorage.setItem('anonymous', active);
        this.on = active;
        this.update();
    },
    toggle: function() {
        this.set( ! this.on );
    },
    update: function() {
        // store the status in Spruce store also so Alpine can see changes
        Spruce.reset('anonymous');
        Spruce.store('anonymous', this.on);

        // Update DOM
        document.querySelector('body').classList[ this.on ? 'add' : 'remove']('anonymous');
    },
    isOn: function() {
        return localStorage.getItem('anonymous') == 'true';
    }
}

window.anonymous.init();
